import { DisposeBag } from "./dispose-bag";

// Subscription 클래스 추가
export class Subscription {
  constructor(private readonly dispose: () => void) {}

  // 체이닝을 위한 disposed 메서드
  disposed(disposeBag: DisposeBag): Subscription {
    disposeBag.add(this.dispose);
    return this;
  }

  // 직접 dispose도 가능
  unsubscribe(): void {
    this.dispose();
  }
}

export class Rx<T> {
  private value: T;
  private subscribers: Set<(value: T) => void> = new Set();

  constructor(initialValue: T) {
    this.value = initialValue;
  }

  get(): T {
    return this.value;
  }

  set(newValue: T): void {
    this.value = newValue;
    this.notifySubscribers();
  }

  // subscribe 메서드가 Subscription 객체를 반환
  subscribe(callback: (value: T) => void): Subscription {
    this.subscribers.add(callback);

    // 즉시 현재 값 전달
    callback(this.value);

    // dispose 함수를 가진 Subscription 객체 반환
    return new Subscription(() => {
      this.subscribers.delete(callback);
    });
  }

  // null이 아닐 때만 이벤트를 전달하는 subscribe 메서드
  subscribeNotNull(callback: (value: NonNullable<T>) => void): Subscription {
    const wrappedCallback = (value: T) => {
      if (value !== null && value !== undefined) {
        callback(value as NonNullable<T>);
      }
    };

    this.subscribers.add(wrappedCallback);

    // 즉시 현재 값 전달 (null이 아닐 때만)
    if (this.value !== null && this.value !== undefined) {
      callback(this.value as NonNullable<T>);
    }

    // dispose 함수를 가진 Subscription 객체 반환
    return new Subscription(() => {
      this.subscribers.delete(wrappedCallback);
    });
  }

  private notifySubscribers(): void {
    this.subscribers.forEach((callback) => {
      try {
        callback(this.value);
      } catch (error) {
        console.error("Subscriber callback error:", error);
      }
    });
  }
}

export { DisposeBag };
